import { useStaticQuery, graphql } from 'gatsby'
import { number } from 'prop-types'
import { marksImagesMain } from './marks'

export type bundledImageObject = {
  download: string;
  id: string;
  imgSrc: string;
  objectName: string;
  possibility: string;
  publicURL?: string | undefined;
  relativeDirectory?: string | undefined;
  relativePath?: string | undefined;
  size: string;
  surrounding: string;
  type: [string];
  base?: string | undefined;
  childImageSharp?: {
    original: {
      height: number;
    }
  }
};

export const marksImage = () => marksImagesMain()

export const bundleImage = ():bundledImageObject[] => {
  const objectData: {
    objectList: {
      nodes: [{
        download:string;
        id:string;
        objectName:string;
        possibility:string;
        size:string;
        surrounding:string;
        type:[string];
        imgSrc:string;
      }]
    }
    object: {
      edges: [{
        node: {
          relativeDirectory:string;
          base: string;
          relativePath: string;
          publicURL: string;
          childImageSharp: {
            original: {
              height: number;
            };
          };
        };
      }]
    }
  } = useStaticQuery<{
    objectList: {
      nodes: [{
        download:string;
        id:string;
        objectName:string;
        possibility:string;
        size:string;
        surrounding:string;
        type:[string];
        imgSrc:string;
      }]
    };
    object: {
      edges: [{
        node: {
          relativeDirectory:string;
          base: string;
          relativePath: string;
          publicURL: string;
          childImageSharp: {
            original: {
              height: number;
            };
          };
        };
      }]
    };
  }>(
    graphql`
      query {
        objectList:allObjectsDataJson {
          nodes {
            download
            id
            objectName
            possibility
            size
            surrounding
            type
            imgSrc
          }
        }
        object:allFile(filter: {extension: {eq: "png"}, relativeDirectory: {glob: "objects"}}) {
          edges {
            node {
              relativeDirectory
              base
              relativePath
              publicURL
              childImageSharp {
                original {
                  height
                }
              }
            }
          }
        }
      }
    `)
  const ObjectListnode = objectData.objectList.nodes
  const objectImages = objectData.object.edges.map(v => v.node)
  const ObjectList = ObjectListnode.map(o => {
    const newObj = {
      ...o,
      ...objectImages.find(imageObject => {
        return imageObject.base === o.imgSrc
      })
    }
    delete newObj.base
    return newObj
  })
  return ObjectList

}

export default null